// Process {{ruby base|ruby text}}
// Original: https://github.com/lostandfound/markdown-it-ruby

// TODO: MITライセンス記載方法について調べて記述する (Original の中にライセンスファイルあり)
'use strict';

function sou_ruby (state, silent) {

  var token,
      tokens,
      max = state.posMax,
      start = state.pos,
      devPos,
      closePos,
      baseText,
      rubyText,
      baseArray,
      rubyArray;

  if (silent) { return false; }
  // {{ ではじまっている  
  if (state.src.charCodeAt(start) !== 0x7b/* { */) { return false; }
  if (state.src.charCodeAt(start + 1) !== 0x7b/* { */) { return false; }
  // {{あ|い}} の長さが必要
  if (start + 6 >= max) {return false; }

  // {{ のあとの位置に移動(2つずらす)
  state.pos = start + 2;

  while (state.pos < max) {

    if (devPos) {

      // }}で終了しているところまでを対象にする
      if (
        state.src.charCodeAt(state.pos) === 0x7D/* } */
        && state.src.charCodeAt(state.pos + 1) === 0x7D/* } */
        && state.src.charCodeAt(state.pos - 1) !== 0x5C/* \ */
      ) {
        closePos = state.pos;
        break;
      }

    } else if (state.src.charCodeAt(state.pos) === 0x7C/* | */ 
      || state.src.charCodeAt(state.pos) === 0xFF5C/* ｜ */
      && state.src.charCodeAt(state.pos - 1) !== 0x5C/* \ */) {
      // NFR-2112 半角(|)と全角の(｜)のどちらにも対応
      devPos = state.pos;
    }

    state.pos++;
  }

  if (!closePos || start + 1 === state.pos) {
    state.pos = start;
    return false;
  }

  state.posMax = state.pos;
  state.pos = start + 1;

  // <ruby class="souruby"> のタグを挿入
  token = state.push('ruby_open', 'ruby', 1);
  token.attrs = [ [ 'class', 'souruby' ] ];
  token.markup  = '{{';

  // 漢字の開始位置は start + 2( {{ の分ずらす)
  baseText = state.src.slice(start + 2, devPos);
  rubyText = state.src.slice(devPos + 1, closePos);

  baseArray = baseText.split('');
  // NFR-2112 半角(|)と全角の(｜)のどちらにも対応
  rubyArray = rubyText.split(/[|｜]/);

  if (baseArray.length === rubyArray.length) {

    baseArray.forEach(function(content, idx) {

      state.md.inline.parse(
        content,
        state.md,
        state.env,
        tokens = []
      );

      tokens.forEach(function(t) {
        state.tokens.push(t);
      });

      token = state.push('rt_open', 'rt', 1);

      state.md.inline.parse(
        rubyArray[idx],
        state.md,
        state.env,
        tokens = []
      );

      tokens.forEach(function(t) {
        state.tokens.push(t);
      });

      token = state.push('rt_close', 'rt', -1);

    });

  } else {

    state.md.inline.parse(
      baseText,
      state.md,
      state.env,
      tokens = []
    );

    tokens.forEach(function(t) {
      state.tokens.push(t);
    });

    token = state.push('rt_open', 'rt', 1);

    state.md.inline.parse(
      rubyText,
      state.md,
      state.env,
      tokens = []
    );

    tokens.forEach(function(t) {
      state.tokens.push(t);
    });

    token = state.push('rt_close', 'rt', -1);

  }

  token = state.push('ruby_close', 'ruby', -1);
  token.markup  = '}}';

  // 閉じ括弧分の2文字ずらす
  state.pos = state.posMax + 2;
  state.posMax = max;

  return true;
}

export default function ruby_plugin(md) {
  md.inline.ruler.before('text', 'sou_ruby', sou_ruby);
};
